<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="admin_set">
      <div style="height: 20px"></div>
      <div style="margin-left: auto; margin-right: auto; width: 400px">
        <el-radio v-model="radio1" label="1" border>1000元</el-radio>
        <el-radio v-model="radio1" label="2" border>5000元</el-radio>
        <el-radio v-model="radio1" label="3" border>10000元</el-radio>
      </div>
      <div style="height: 20px"></div>
      <!-- <img class="code" src="../assets/code.png" /> -->
      <div style="margin-left: auto; margin-right: auto; width: 400px">
        <el-radio
          v-model="radio1"
          label="7"
          border
          size="medium"
          style="float: left"
          >其他金额</el-radio
        >
        <div style="width: 50%; float: left">
          <el-input
            v-model="input"
            placeholder="请输入充值金额"
            type="number"
            :readonly="readonly"
          ></el-input>
        </div>
        <div style="height: 30px"></div>
        <!-- <div style="text-align: center">15210840086 支付宝</div> -->
        <div style="height: 30px"></div>
        <div style="margin-left: auto; margin-right: auto; width: 400px">
          <div style="text-align: center"><span style="color:red">线上充值默认扣除支付宝收取的手续费</span>（充值金额的0.01，即冲100，实际到账99元。）</div>
          <div style="text-align: center">（联系客服充值无手续费，需要对公开票的，请联系客服咨询充值。）</div>
          <div style="text-align: center">财务QQ：3309393986</div>
          <div style="text-align: center;color:red">（会员用户，请勿使用线上充值功能，否则财务将会扣除支付宝所收取的服务费，并取消其会员资格。）</div>
        </div>
        <div style="height: 40px"></div>
        <el-button
          style="margin-left:auto;margin-right:auto;width:400px"
          type="primary"
          size="medium"
          @click="pay"
        >立即充值</el-button>
      </div>
    </div>
    <div id="pay"></div>
  </div>
</template>

<script>
import HeadTop from "../components/HeadTop";
import { mapState } from "vuex";
import myAxios from "../myAxios";
let Base64 = require("js-base64").Base64;

export default {
  data() {
    return {
      radio1: "1",
      input: "",
      readonly: true, //输入框是否为只读
    };
  },
  components: {
    HeadTop,
  },
  watch: {
    radio1: function (val) {
      if (val == "7") {
        this.readonly = false;
      } else {
        this.readonly = true;
      }
    },
  },
  computed: {},
  methods: {
    pay() {
      let price = 1000;
      switch (this.radio1) {
        case "1":
          price = 1000;
          break;
        case "2":
          price = 5000;
          break;
        case "3":
          price = 10000;
          break;
        case "4":
        default:
          price = this.input;
          break;
      }
      if (!price) {
        this.$notify.warning({
          title: "提示",
          message: "请输入充值金额",
          offset: 100,
        });
        return;
      }
      let username = localStorage.getItem("username");
      myAxios
        .post(`/client_user/Pay/v1?username=${username}&price=${price}`)
        .then((res) => {
          const div = document.createElement("div");
          div.innerHTML = Base64.decode(res.data);
          document.body.appendChild(div);
          document.forms.alipaysubmit.submit();
        });
    },
  },
};
</script>

<style lang="less">
@import "../style/mixin";
.explain_text {
  margin-top: 20px;
  text-align: center;
  font-size: 20px;
  color: #333;
}
.admin_set {
  width: 60%;
  background-color: #f9fafc;
  min-height: 400px;
  margin: 20px auto 0;
  border-radius: 10px;
  ul > li {
    padding: 20px;
    span {
      color: #666;
    }
  }
}
.admin_title {
  margin-top: 20px;
  .sc(24px, #666);
  text-align: center;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  margin-top: 10px;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
.code {
  width: 40%;
  margin-left: 30%;
}
</style>
